import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 px-4 bg-espresso-900 text-cream-100" data-id="element-63">
      <div className="max-w-3xl mx-auto text-center" data-id="element-64">
        <motion.div initial={{
        scale: 0.9,
        opacity: 0
      }} whileInView={{
        scale: 1,
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex flex-col items-center" data-id="element-65">
          <ShieldCheck className="w-20 h-20 text-gold-500 mb-6" data-id="element-66" />
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-67">GARANTÍA</h2>
          <h3 className="text-2xl text-gold-500 font-serif italic mb-6" data-id="element-68">
            Garantía de confianza de 30 días
          </h3>
          <p className="text-xl text-cream-200/90 leading-relaxed max-w-xl" data-id="element-69">
            Si no te gusta, te devolvemos tu dinero.
            <br data-id="element-70" />
            <span className="font-bold text-white mt-2 block" data-id="element-71">
              Sin preguntas.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}